import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { MonPoste } from "@/components/settings/StationsTab";
import { AccountBlocks } from "@/components/AccountBlocks";
import { TeamSecurityCard } from "@/components/TeamSecurityCard";
import { useAuth } from "@/context/AuthContext";

// Standalone "Mon poste" page — accessible to every role (agents included),
// with the sign-out action.
const MyStationPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/connexion", { replace: true });
  };

  return (
    <div data-testid="my-station-page" className="space-y-6 max-w-3xl">
      <header>
        <h1 className="font-heading font-bold text-slate-900 text-2xl sm:text-3xl tracking-tight">Mon poste</h1>
        <p className="text-sm text-slate-500 mt-1">
          {user?.name} · {user?.email}
        </p>
      </header>

      <MonPoste />

      {user?.role === "superviseur" && <TeamSecurityCard />}

      <AccountBlocks />

      <div className="rounded-xl border border-slate-200 bg-white shadow-sm p-5 flex items-center justify-between gap-3">
        <div>
          <p className="font-heading font-semibold text-slate-800 text-sm">Session</p>
          <p className="text-xs text-slate-400 mt-0.5">Vous restez connecté 30 jours sur cet appareil.</p>
        </div>
        <button
          type="button"
          data-testid="logout-button"
          onClick={doLogout}
          className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white text-slate-700 text-sm font-medium px-4 py-2.5 hover:border-red-300 hover:text-red-700 transition-colors shrink-0"
        >
          <LogOut className="h-4 w-4" /> Se déconnecter
        </button>
      </div>
    </div>
  );
};

export default MyStationPage;
